<template>
  <route_final>
   <div class="animated fadeIn">
    <b-row>
     <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
       <div slot="header">
        <strong>Final Generated Route</strong>
       </div>
       <b-row>
        <b-col sm="4">
         <b-form-group label="From Date:" :label-cols="4">
          <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'></v-date-picker>
         </b-form-group>
        </b-col>
        <b-col sm="4">
         <b-form-group label="To Date:" :label-cols="4">
          <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'></v-date-picker>
         </b-form-group>
        </b-col>
        <b-col sm="4">
         <b-button type="submit" size="md" variant="primary" @click="getFinalizedPlans()"> Search</b-button>
         <b-button type="submit" size="md" variant="danger" @click="clearDate()" style="margin-left: 10px"> clear</b-button>
        </b-col>
        <b-col sm="12">
         <b-card v-if="vehicleAcceptedLoads.length>0">
          <b-list-group flush>
           <b-list-group-item v-for="(vehicle,index) in vehicleAcceptedLoads" :key="index" style="box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;">
            <b-row>
             <b-col sm="10" class="text-left">
              <b-button variant="primary" class="w-100 text-left" @click="toggleCollapse(index, vehicle)">
               <b-row>
                <b-col sm="2" class="bordered-col" title="Vehicle No." style="font-size:12px">Vehicle No: {{ vehicle.vehicle_no }}</b-col>
                <b-col sm="2" class="bordered-col" title="Planning Date." style="font-size:14px">Planning Date: {{ vehicle.created_date }}</b-col>
                <b-col sm="2" class="bordered-col" title="Transporter Name." style="font-size:14px">Transporter: {{ vehicle.transporter_name }}</b-col>
                <b-col sm="2" class="bordered-col" title="Vehicle Type." style="font-size:14px">Vehicle Type: {{ vehicle.actual_vehicle_type }}</b-col>
                <b-col sm="1" class="bordered-col" title="Capacity" style="font-size:14px">Capacity: {{ vehicle.vehiclecapacity }}</b-col>
                <b-col sm="1" class="bordered-col" title="Occupied" style="font-size:14px">Occupied: {{ vehicle.occupied?vehicle.occupied:vehicle.occupied }}</b-col>
                <b-col sm="1" class="bordered-col" title="Space" style="font-size:14px">Space: {{ vehicle.space }}</b-col>
                <b-col sm="1" class="bordered-col" title="Vehicle Type" style="font-size:14px">Type: {{vehicle.vehicle_type}}</b-col>
               </b-row>
              </b-button>
             </b-col>
             <b-col sm="2" class="text-right" style="margin:auto 0">
              <b-button :disabled="vehicle.editable_flag=='yes'" variant="primary" @click="getMapData(vehicle,index)">Map{{ index+1 }}</b-button>&nbsp; <a :href="vehicle.filepath" target="_blank">
               <b-button type="submit" size="md" variant="success"> CSV</b-button>
              </a>
             </b-col>
            </b-row>
            <b-collapse @hide="vehicleDrawerClose" :visible="activeCollapseFinal === index" :id="'collapse-' + index">
             <br>
             <b-row>
              <b-col sm="12" class="text-right">
               <p>
                <b>Total Records : <span style="color:red;">{{ vehicle.only_loads.length }}</span>
                </b>
               </p>
              </b-col>
             </b-row>
             <b-row>
              <b-col sm="12">
               <b-table show-empty responsive :items="vehicle.only_loads" :fields="loadfields" :bordered="bordered" :outlined="outlined" :busy="isBusy" :tbody-tr-class="rowClass">
                <div slot="table-busy" class="text-center text-danger my-2">
                 <b-spinner class="align-middle"></b-spinner>
                 <strong>Loading...</strong>
                </div>
                <template slot="action" slot-scope="row">
                 <div>
                  <i class="fa fa-pencil-square-o"></i> {{ row.item.sequenceno }}
                 </div>
                </template>
               </b-table>
              </b-col>
             </b-row>
            </b-collapse>
           </b-list-group-item>
          </b-list-group>
         </b-card>
        </b-col>
       </b-row>
      </b-card>
      <!-- City Map -->
      <b-modal title="Map" @ok="showCityMap=false" v-model="showCityMap" hide-footer size="xl" @shown="initMapLoad">
       <b-row>
        <b-col md="12">
         <b-card class="mb-2">
          <b-card-text>
           <b-col v-if="totalDistanceTravel" md="12" class="text-right">
            <b>Total Duration :- </b>
            <span style="color:red">
             <b>{{ totalDuration }} Hrs </b>
            </span>
            <b>Total Distance :- </b>
            <span style="color:red">
             <b>{{ totalDistanceTravel }} KM </b>
            </span>
           </b-col>
           <div id="map" style="height: 500px;"></div>
           <b-modal v-model="showModal" hide-footer title="Load" size="xl">
            <div class="d-block text-center">
             <b-col sm="12" class="text-right">
              <p>
               <b>Total Records : <span style="color:red;">{{ pincodeWiseLoad.length }}</span>
               </b>
              </p>
             </b-col>
             <b-table show-empty responsive stacked="md" :items="pincodeWiseLoad" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" :bordered="bordered" :outlined="outlined" :busy="isBusy">
              <div slot="table-busy" class="text-center text-danger my-2">
               <b-spinner class="align-middle"></b-spinner>
               <strong>Loading...</strong>
              </div>
             </b-table>
            </div>
            <b-button class="mt-3 float-right" variant="danger" @click="closeModal()">Close</b-button>
           </b-modal>
          </b-card-text>
         </b-card>
        </b-col>
       </b-row>
      </b-modal>
      <!-- <b-modal v-model="viewLoadModal" hide-footer title="Loads Detail" size="xl">
       <div class="d-block text-center">
        <b-col sm="12" class="text-right">
         <p>
          <b>Total Records : <span style="color:red;">{{ viewLoadArr.length }}</span>
          </b>
         </p>
        </b-col>
        <b-table show-empty responsive stacked="md" :items="viewLoadArr" :fields="viewfields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" :bordered="bordered" :outlined="outlined" :busy="isBusy">
         <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
         </div>
       
        </b-table>
       </div>
       <b-button class="mt-3 float-right" variant="danger" @click="closeModal()">Close</b-button>
      </b-modal> -->
      <!-- City Map -->
     </b-col>
    </b-row>
   </div>
  </route_final>
 </template>
  <script>
    //  import DirectionsRenderer from "./DirectionsRenderer";
     import spinner from './Loader/spinner.vue';
    //  import customMarker from "./customMarker.vue";
    import CONSTANTS from "@/utils/constants";
    import Utils from "@/utils";
    import Vue from "vue";
    export default {
       
      data() {
        return {
          vehicleAcceptedLoads: [],
          vehicleRejectedLoads: [],
          center: {
            lat: 0,
            lng: 0
          },
         
          available_vehiclelist: [],
          available_list: '',
          
          optionsHub: [],
          HubData: [],
          valueVehicle: [],
          optionsVehicle: [],
          vehicleData:[],
          fieldVehicle: {
            text: 'name',
            value: 'id'
          },
          selectedHub: '',
          vehicleLoads:[],
          pendingLaods:[],
           
          showCityMap:false,
          waypoints : [],
          sourceLatLng : [],
        
          Loadmap:null,
          directionsRenderers:null,
          directionsService:null,
          showloadtypedetails:false,
         
          LoadmapWise:null,
          waypointsWise:[],
          directionsRenderer:null,
         
          cityWiseLatLng:[],
          sourceLatLngLoadWise:[],
          customModal:false,
          modalMessage:"",
          showModal:false,
          dest_pincode:[],
          pincodeWiseLoad:[],
          fields:[
            { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
            { key: 'loadid', label: 'Load id', sortable: true},
            { key: 'userid', label: 'User ID', sortable: true},
            { key: 'noofboxes', label: 'No of boxes', sortable: true},
            // { key: 'week_off_days', label: 'Week Off', sortable: true},
            // { key: 'fuel_type', label: 'Fuel Type', sortable: true}, 
             { key: 'shipmentvolumetricweight', label: 'Volumetric Weight', sortable: true},  
            { key: 'dest_state', label: 'Destination State', sortable: true },
            { key: 'dest_city', label: 'Destination City', sortable: true },
            // { key: 'destinationaddress', label: 'Destination Address', sortable: true },
            { key: 'destinationpincode', label: 'Destination Pincode', sortable: true },
            // { key: 'loadpotype', label: 'Load PO Type', sortable: true },
            // { key: 'action', label: 'Action', sortable: true },
            
          ],
          viewfields:[
          { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
            { key: 'loadid', label: 'Load id', sortable: true},
            { key: 'userid', label: 'User ID', sortable: true},
            { key: 'noofboxes', label: 'No of boxes', sortable: true},
             { key: 'shipmentvolumetricweight', label: 'Volumetric Weight', sortable: true},  
            { key: 'dest_state', label: 'Destination State', sortable: true },
            { key: 'dest_city', label: 'Destination City', sortable: true },
            { key: 'destinationpincode', label: 'Destination Pincode', sortable: true },
            // { key: 'loadpotype', label: 'Load PO Type', sortable: true },
            // { key: 'action', label: 'Action', sortable: true },  
          ],
          isBusy: false,
          viewLoadModal:false,
          viewLoadArr:[],
          selectLoad :[],
          mapIndex:null,
          spinnerFlag:false,
          totalDistanceTravel:0,
          totalDuration:0,
          generate_route_Link:'',
          tempIndex: null,
          sequenceIndex:null,
          sequenceLength:null,
          emptySequense:false,
          selectDateFrom: new Date(),
          selectDateTo:new Date(),
          activeCollapseFinal:null,
          accessBody:[],
          isReadOnly:false,
          loadfields:[
            { key: 'userid', label: 'User Id', sortable: true, sortDirection: 'desc' },
            { key: 'loadid', label: 'Load id', sortable: true},
            { key: 'noofboxes', label: 'No of Boxes', sortable: true},
            { key: 'loadpotype', label: 'Load PO Type', sortable: true },
            { key: 'hub_city', label: 'WH/HUB', sortable: true},
            { key: 'shipmentvolumetricweight', label: 'Vol. Wt', sortable: true}, 
            { key: 'shippincode', label: 'Ship Pincode', sortable: true},   
            { key: 'parentawb', label: 'AWB', sortable: true},   
            { key: 'destinationcompanyname', label: 'Company Name', sortable: true},
            { key: 'origin_city', label: 'City', sortable: true },
            { key: 'zone_title', label: 'Hub Zone', sortable: true },
            { key: 'dest_city', label: 'Dest City', sortable: true },
            { key: 'dest_state', label: 'Dest State', sortable: true },
            { key: 'zoneinscandate', label: 'Zone Inscan', sortable: true },
            { key: 'shipoutdate_time', label: 'shipout', sortable: true },
            { key: 'destinationaddress', label: 'Address', sortable: true },
            { key: 'action', label: 'Sequence', sortable: true },  
        ],
        };
      },
      components: {
      // DirectionsRenderer,
      spinner,
      // customMarker,
      },
      props:['selectedHub'],
      created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.userType = userInfo.user_type;
        this.Usersysuser = userInfo.sysusermasterid;
        this.user_id = userInfo.sysusermasterid;
        this.accessBody = userInfo.body;
        this.ischeckbodyvalidation();
        this.getFinalizedPlans();
        this.activeCollapseFinal = null;
        const storedactiveCollapseFinal = localStorage.getItem("activeCollapseFinal");
        if (storedactiveCollapseFinal) {
            this.activeCollapseFinal = storedactiveCollapseFinal;
        }
      },
    //   watch: {
    //   selectedHub() {
    //         if (this.selectedHub=='' || this.selectedHub==null || this.selectedHub== undefined || this.selectedHub=='null') {
               
    //             this.selectedHub=''; 
    //         }
    //         else{
    //             this.customer={};
    //             this.getFinalizedPlans();
               
    //         }
    //     }
    // },
      methods: {
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=="Route History" && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=="Route History" && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
        },
        getMapData(vehicle,index){
         
          this.mapIndex=null;    
          this.mapIndex=index;
          let vehicleDetails=localStorage.getItem('genrateVehicleDetails')
          let vehicleData= JSON.parse(vehicleDetails);
        
          this.dest_pincode=vehicleData[index].destination_sequence;
          localStorage.setItem('destination_sequence',JSON.stringify(this.dest_pincode));
         
          let waypoints = vehicleData[index].destination_sequence;
        
          this.waypoints=waypoints.map(item=>({
            "lat": parseFloat(item.latlong.x),
            "lng": parseFloat(item.latlong.y),
            "pincode":item.pincode,
            "unikey":item.unikey
          }))
          //  console.log(" this.waypoints--------------->", this.waypoints);
          this.showCityMap=true;
  
        },
        
      initMapLoad() {
          this.Loadmap = new google.maps.Map(document.getElementById('map'), {
              center: { lat: 12.971598, lng: 77.594562 },
              zoom: 10,
          });
  
          this.directionsService = new google.maps.DirectionsService();
          this.directionsRenderers = new google.maps.DirectionsRenderer({
              map: this.Loadmap,
              suppressMarkers: true,
              polylineOptions: {
                  strokeColor: 'blue',
                  strokeWeight: 4
              }
          });
  
          const waypointsLatLng = this.waypoints.map(waypoint => new google.maps.LatLng(waypoint.lat, waypoint.lng));
          
          const request = {
              origin: waypointsLatLng[0],
              destination: waypointsLatLng[waypointsLatLng.length - 1],
              waypoints: this.waypoints.slice(1, -1).map(waypoint => ({
                  location: new google.maps.LatLng(waypoint.lat, waypoint.lng),
                  stopover: true
              })),
              travelMode: google.maps.TravelMode.DRIVING,
          };
          
          this.totalDistanceTravel = 0;
          this.totalDuration=0;
          this.directionsService.route(request, (response, status) => {
              if (status === 'OK') {
                  this.directionsRenderers.setDirections(response);
  
                  const legs = response.routes[0].legs;
                  let sum = 0;
                  let durations=0;
                  legs.forEach((leg, index) => {
                  if (this.waypoints[index + 1]) {
                      const distance = `From ${this.waypoints[index].pincode} to ${this.waypoints[index + 1].pincode} distance ${leg.distance.text}`;
                      sum += parseFloat(leg.distance.text.replace(/[^\d.-]/g, ''));
                      durations += parseFloat(leg.duration.text.replace(/[^\d.-]/g, ''));
                      const marker = this.markers[index + 1];
                      if (marker) {
                          marker.setTitle(distance);
                      }
                  } else {
                      console.log("No more waypoints to process.");
                  }
              });
              this.totalDistanceTravel=sum.toFixed(2);
              this.totalDuration=(durations/60).toFixed(2);

              } else {
                  window.alert('Directions request failed due to ' + status);
              }
          });
  
          // Create markers for each waypoint
          this.markers = [];
          this.waypoints.forEach((waypoint, index) => {
            
              const labelChar = String.fromCharCode(65 + index); // 65 is the ASCII code for 'A'
  
              const marker = new google.maps.Marker({
                  position: new google.maps.LatLng(waypoint.lat, waypoint.lng),
                  map: this.Loadmap,
                  icon: {
                      path: google.maps.SymbolPath.CIRCLE,
                      scale: 10, // Adjust scale to cover the icon circle
                      fillColor: index === 0 ? 'green' :
                          (index === this.waypoints.length - 1 ? 'red' : 'yellow'),
                      fillOpacity: 1,
                      strokeColor: 'black',
                      strokeWeight: 1,
                      labelOrigin: new google.maps.Point(0, 0) // Adjust to position the label correctly
                  },
                  title: `Start Point - ${waypoint.pincode}`, // Initial title
                  label: {
                      text: labelChar,
                      color: 'black', // Ensure this is visible against the icon color
                      fontSize: '16px', // Increase the size to cover the icon circle
                      // fontWeight: 'bold',
                  }
              });
  
              this.markers.push(marker);
  
              // Handle marker click event
              if (index > 0) {
                  marker.addListener("click", () => {
                      this.pincodeWiseLoad = [];
                      let vehicleDetails = localStorage.getItem('genrateVehicleDetails');
                      let vehicleData = JSON.parse(vehicleDetails);
                      let loads = vehicleData[this.mapIndex].loads;
                      let clicked_pincode = this.waypoints[index].pincode;
  
                      this.pincodeWiseLoad = loads.filter(item => item.destinationpincode === clicked_pincode);
  
                      this.showModal = true;
                  });
              }
          });
      },
  
  
      closeModal() {
            this.showModal = false;
            this.viewLoadModal=false;
          },
  
       // Load Map End
        clear: function() {
          this.available_list='',
          this.totalvehiclelist = 0;
          this.selectedHub='';
          this.vehicleAcceptedLoads = [];
          this.pendingLaods=[];
          localStorage.setItem('genrateVehicleDetails', '');
        
        },
  
        
       
        showWHlist: function() {
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          var csvObj = {
            sysusermasterid:`${userInfo.sysusermasterid}`,
            usertype:`${userInfo.user_type}`
          };
       
          // return false;
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj).then(result => {
            if (result.body.returnmsg === 'Successful') {
              this.optionsHub = [];
              this.HubData = result.body.returnvalue;
              var data = [];
              this.HubData.forEach(function(srData) {
                data.push({
                  key: srData.hubid,
                  label: srData.hubid + " - " + srData.hubname
                });
              });
              this.optionsHub = data;
            } else {
              this.HubData = [];
            }
          }).catch(ex => {
            console.log("error-----", ex);
          });
        },
        // updateSelect(){
        //  this.vehicleAcceptedLoads=[];
        //   this.showVehiclelist();
        // },
     
        viewLoad(pincode,index){
          this.mapIndex=null;
          this.mapIndex=index;
         
          if(pincode.allloads.length){
            this.viewLoadArr=pincode.allloads;
          }else{
            this.viewLoadArr=[];
          }
         
          this.viewLoadModal=true;
        },
      

      getFinalizedPlans() {
          document.getElementById("overlay").style.display = "block";
          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
          var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
          var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
          if(this.selectedHub!=''){
            let getHubName =this.selectedHub.label.split('-');
            let trimSpace=getHubName[1].trim();
            if(formatdateto< fromdate){  
              this.$fire({
                      text:"To date need to be greater than From date",
                      type: "warning",
                      timer: 30000
                    }); 
                document.getElementById("overlay").style.display = "none";
                    // this.isBusy = false; 
                    return false;       
            }
            const obj = {
                hubid:`${this.selectedHub.key}`,
                fromdate:`${fromdate}`,
                todate:`${formatdateto}`,
                pageno:"1"
            }
          // return false;
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getFinalizedPlans`, obj).then((result) =>{
            document.getElementById("overlay").style.display = "none";
           
            if (result.body.returnmsg === "Successful") {
              this.vehicleAcceptedLoads = result.body.returnvalue;
              let vehicleDetails=result.body.returnvalue;
              localStorage.setItem('genrateVehicleDetails', JSON.stringify(vehicleDetails));
             
              this.totalvehiclelist= this.vehicleAcceptedLoads.length;
              // this.showVehiclelist();
            } else {
              this.vehicleAcceptedLoads = [];
              
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          }).catch((ex) => {
            console.log("error", ex);
          });
          }else{
            this.$fire({
              text: "Please Select Hub",
              type: "warning",
              timer: 30000,
            });
            document.getElementById("overlay").style.display = "none";
            return false;
          }
          
        },
      // viewLoad(pincode, index) {
      // // Logic to view loads
      // },
      clearDate() {
      
        this.selectDateFrom=new Date();
        this.selectDateTo=new Date();   
        this.getFinalizedPlans();       
    },
      formatDate: function(date) {
          var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();
          if (month.length < 2) month = "0" + month;
          if (day.length < 2) day = "0" + day;
          return [year, month, day].join("-");

      },
      toggleCollapse(index,item) {
        // Toggle the collapse based on the current state
        this.activeCollapseFinal = this.activeCollapseFinal === index ? null : index;
        // Update localStorage
        localStorage.setItem("activeCollapseFinal", this.activeCollapseFinal);
      },
      vehicleDrawerClose(){

      }
        
     
      },
      
    };
  </script>
  <style scoped>
  .custom-source-marker-container {
    position: absolute;
    z-index: 999; /* Adjust the z-index value to ensure it's above the DirectionsRenderer markers */
    top: 0; /* Adjust positioning as needed */
    left: 0; /* Adjust positioning as needed */
  }
    .routetable th,
    td,th {
      text-align: center;
    }
  
    .route-border {
      border-bottom: 1px solid #c9bebe;
      margin: 30px 0px 20px 0px;
    }
  
    #overlay {
      position: fixed;
      /* Sit on top of the page content */
      /*display: none;*/
      /* Hidden by default */
      width: 100%;
      /* Full width (cover the whole page) */
      height: 100%;
      /* Full height (cover the whole page) */
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      /* Black background with opacity */
      z-index: 9999;
      /* Specify a stack order in case you're using a different order for other elements */
      cursor: pointer;
      /* Add a pointer on hover */
    }
  
    .loader {
      position: fixed;
      ;
      border: 5px solid #f3f3f3;
      border-radius: 50%;
      border-top: 5px solid #3498db;
      width: 50px;
      height: 50px;
      left: 50%;
      top: 50%;
      -webkit-animation: spin 2s linear infinite;
      /* Safari */
      animation: spin 2s linear infinite;
    }
  
    .loading {
      position: relative;
      width: 50px;
      height: 50px;
      left: 50%;
      top: 56%;
    }
    .customMarker{
      position: absolute;
      left: 0px;
      top: 0px;
      z-index: -1;
    }
  
    /* Safari */
    @-webkit-keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
      }
  
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
  
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
  
      100% {
        transform: rotate(360deg);
      }
    }
    .dot{
      margin: 5px;
    }
    .red-dot {
    width: 20px;
    height: 20px;
    background-color: red;
    border-radius: 50%;
    display: inline-block;
    border: 2px black solid;
  }
  .green-dot {
    width: 20px;
    height: 20px;
    background-color: green;
    border-radius: 50%;
    display: inline-block;
    border: 2px black solid;
  }
  .yellow-dot {
    width: 20px;
    height: 20px;
    background-color: yellow;
    border-radius: 50%;
    display: inline-block;
    border: 2px black solid;
  }
  .modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
  }
  
  .close {
    color: #aaaaaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }
  
  .close:hover,
  .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }
  .bordered-col {
    border: 1px solid #ddd; /* Light grey border */
    /* background-color: white; White background */
    padding: 8px; /* Optional: add some padding */
  }
  </style>
  </style>